module.exports = __webpack_public_path__ + "img/svg/notification.811351ca30259fd9adf63492b37d122b.svg";